// @ts-nocheck
import { TLanguages } from '../config/locale'
import BigNumber from 'bignumber.js'
import dayjs from 'dayjs'
import { TUnitType } from 'core/types'
import { getIsStableCoinBase } from './helper/contract/common'

//输入框只能输入数字校验
export function inputNumberCheck(str) {
  //清除“数字”和“.”以外的字符
  str = str.replace(/[^\d.]/g, '')
  //验证第一个字符是数字而不是.
  str = str.replace(/^\./g, '')
  //只保留第一个. 清除多余的.
  str = str.replace(/\.{2,}/g, '.')
  str = str.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')

  return str
}

/**
 * 截取小数点
 * data: 需要截取的数据
 * decimal： 截取位数
 * tips: 拷贝于vue-h5项目byEdwin。截取小数点，保留指定位数，不用toFixed估计是因为js数字精度问题
 * **/
export const spliceDecimal = (data: number | string, decimal: number | string) => {
  if (typeof data !== 'string') {
    data = data + ''
  }
  //如果有小数，截取
  const index = data.indexOf('.')

  if (index != -1) {
    if (decimal != 0) {
      data = data.slice(0, index + 1 + parseInt(decimal as unknown as string))
    } else {
      data = data.slice(0, index)
    }
  }
  return data
}

/**
 *  大数据精度展示
 */
export const bigDataNumFloat = (currentLocale: TLanguages) => (num: string | number, decimal?: number) => {
  let newNum = num !== undefined || num !== null ? String(num) : '--'
  const nn = Number(newNum)

  decimal = decimal ? decimal : 4

  if (['zh_CN', 'zh_HK'].includes(currentLocale)) {
    const TenThousand = 10000
    const Billion = 100000000
    if (nn > TenThousand && nn < Billion) {
      // @ts-ignore
      newNum = spliceDecimal(newNum / TenThousand, decimal) + '万'
    }
    if (nn >= Billion) {
      // @ts-ignore
      newNum = spliceDecimal(newNum / Billion, decimal) + '亿'
    }
    if (nn < TenThousand) {
      newNum = spliceDecimal(newNum, decimal)
    }
  } else {
    const thousand = 1000
    const million = 1000000
    const Billion = 1000000000
    if (nn > thousand && nn < million) {
      // @ts-ignore
      newNum = spliceDecimal(newNum / thousand, decimal) + 'K'
    }
    if ((nn > million || nn == million) && nn < Billion) {
      // @ts-ignore
      newNum = spliceDecimal(newNum / million, decimal) + 'M'
    }
    if (nn > Billion || nn == Billion) {
      // @ts-ignore
      newNum = spliceDecimal(newNum / Billion, decimal) + 'B'
    }
    if (nn < thousand) {
      newNum = spliceDecimal(newNum, decimal)
    }
  }

  return newNum
}

/**
 * 科学计数法转换为正常数值
 * @param num 要转义的科学计数法
 * @returns 转换后的正常数值
 */
export const toNonExponential = (num: number): string => {
  if (Number.isNaN(num)) {
    return num.toString()
  }

  const m = num.toExponential().match(/\d(?:\.(\d*))?e([+-]\d+)/)
  if (!m) {
    return num.toString()
  }

  const decimal = Math.max(0, (m[1] || '').length - parseInt(m[2]))
  return num.toFixed(decimal)
}

export const rateFilter =
  ({ exchangeRate, lang }) =>
  (value: number | string, flag?: string) => {
    if (isNaN(value) || !exchangeRate) {
      return value
    }

    let num = toNonExponential(value / exchangeRate)
    let decimal = 2

    //使用算法截取
    const array = num.toString().split('.')
    if (array[0] && array[0] > 0) {
      decimal = 2
    } else {
      if (array[1]) {
        const numStr = array[1].toString()
        let i = 0
        for (i; i < numStr.length; i++) {
          if (numStr[i] > 0) {
            break
          }
        }
        if (i > 8) {
          decimal = 8
        } else if (i == 0) {
          decimal = i + 2
        } else {
          decimal = i + 3
          if (decimal > 8) {
            decimal = 8
          }
        }
      }
    }

    num = num.toString()
    const index = num.indexOf('.')
    if (index != -1) {
      num += '0000000000' //补0需求
      num = num.slice(0, index + 1 + decimal)
    } else {
      //整数补0
      num = parseFloat(num).toFixed(decimal)
    }

    if (flag) {
      num = bigDataNumFloat(lang)(num, 2)
    }

    return num
  }

/**
 * 获取倒计时，所需时间距离 now 的倒计时
 * @param { Date } date 需要转换的时间
 */
export const getCountdown = (date) => {
  // 处理非时间戳格式
  if (typeof date === 'string') {
    date = date.replace(/\-/g, '/')
  }
  const timestamp = new Date(date).getTime() - Date.now()

  const dateDiff = Math.floor(timestamp)
  let times = {
    d: '0',
    h: '00',
    m: '00',
    s: '00',
  }
  if (isNaN(dateDiff) || dateDiff <= 0) {
    return times
  }
  const hour = dateDiff % (24 * 3600 * 1000)
  const minute = hour % (3600 * 1000)
  const second = minute % (60 * 1000)

  const d = Math.floor(dateDiff / (24 * 3600 * 1000)).toString()
  const h = Math.floor(hour / (3600 * 1000)).toString()
  const m = Math.floor(minute / (60 * 1000)).toString()
  const s = Math.round(second / 1000).toString()
  times = {
    d,
    h: h >= 10 ? h : '0' + h,
    m: m >= 10 ? m : '0' + m,
    s: s >= 10 ? s : '0' + s,
  }
  return times
}

export function reloadWithURLParams(params: Record<string, string>) {
  const url = new URL(window.location.href)
  Object.keys(params).forEach((key) => url.searchParams.set(key, params[key]))
  window.location.href = url.toString()
}

export function getAndRemoveURLParams<T extends string[] | string>(paramsToRemove: T): T {
  const url = new URL(window.location.href)
  const params = new URLSearchParams(url.search)
  const result = {}

  const keys = typeof paramsToRemove === 'string' ? [paramsToRemove] : paramsToRemove
  keys.forEach((param) => {
    if (params.has(param)) {
      result[param] = params.get(param)
      params.delete(param)
    }
  })

  if (params.toString()) {
    window.history.replaceState({}, '', `${url.pathname}?${params.toString()}`)
  } else {
    window.history.replaceState({}, '', url.pathname)
  }

  return typeof paramsToRemove === 'string' ? result[paramsToRemove] : result
}

/**
 * 此方法不允许在渲染时调用，会导致打包失败（window is not defined）
 * 使用应当包裹在 useEffect 中
 * const [icCode, setIcCode] = useState('')
 * useEffect(() => {if (getSearchParams('icCode')) setICCode(getSearchParams('icCode'))}, [])
 * @param key
 */
export function getSearchParams<T extends string[] | string>(key: T): T {
  if (typeof window === 'undefined') {
    return {}
  }
  const url = new URL(window.location.href)
  const params = new URLSearchParams(url.search)
  const result = {}

  const keys = typeof key === 'string' ? [key] : key
  keys.forEach((param) => {
    if (params.has(param)) {
      result[param] = params.get(param)
    }
  })

  return typeof key === 'string' ? result[key] : result
}

//加法
export const bigNumberAdd = (num1, num2) => {
  if ((!num1 && num1 !== 0) || (!num2 && num2 !== 0)) return ''

  const x = new BigNumber(num1)
  const y = new BigNumber(num2)
  const n = x.plus(y)
  return toNonExponential(new BigNumber(n))
}
//减法
export const bigNumberMinus = (num1, num2) => {
  if ((!num1 && num1 !== 0) || (!num2 && num2 !== 0)) return ''

  const x = new BigNumber(num1)
  const y = x.minus(num2)
  return toNonExponential(new BigNumber(y))
}
//乘法
export const bigNumberTimes = (num1, num2) => {
  if ((!num1 && num1 !== 0) || (!num2 && num2 !== 0)) return ''

  const x = new BigNumber(num1)
  const y = x.times(num2)
  return toNonExponential(new BigNumber(y))
}
//除法
export const bigNumberDivide = (num1, num2) => {
  if ((!num1 && num1 !== 0) || (!num2 && num2 !== 0)) return ''

  const x = new BigNumber(num1)
  const y = x.div(num2)
  return toNonExponential(new BigNumber(y))
}
/**
 * 展示用的 截取小数点, 补0
 * data: 需要截取的数据
 * decimal： 截取位数
 * **/
export const showSpliceDecimal = (data, decimal) => {
  if (isNaN(Number(data))) {
    // 用于处理输入数据如 123.4K 的情况
    if (!isNaN(parseFloat(data))) return data
    return '--'
  }
  if (typeof data !== 'string') {
    data = data + ''
  }

  //如果有小数，截取
  let index = data.indexOf('.')

  if (index == -1) {
    data += '.0000000000' //整数补零
  } else {
    data += '0000000000' //补0需求
  }
  index = data.indexOf('.')

  if (decimal != 0) {
    data = data.slice(0, index + 1 + parseInt(decimal))
  } else {
    data = data.slice(0, index)
  }

  return data
}

//获取合约面值精度
export const getUnitAmount = (unitAmount: string | number) => {
  const index = String(unitAmount).indexOf('.')
  if (index == -1) {
    return 0
  } else {
    return String(unitAmount).slice(index + 1).length
  }
}

// 获取对应合约单位精度
export const getUnitDigit = ({ isUSDTBased, unitAmount, marketPriceDigit, unit }: TGetUnitDigitParams) => {
  // 使用交易对价格精度(marketPriceDigit)
  if (unit === 'usdt') {
    return marketPriceDigit
  }
  if (unit === 'crypto') {
    // U本位模式：使用合约面值精度(getUnitAmount(unitAmount))
    // 币本位模式：固定使用 4 位精度
    return isUSDTBased ? getUnitAmount(unitAmount) : 4
  }

  return 0
}

/**
 *
 * @param param0 : {
 *  - digit:保留小数位
 *  - unit:当前单位类型 cont:张  usdt  quote:标记币
 *  - quote: 计价币 用于判断是币本位还是USDT本位
 *  - indexBase: 标记币
 *  - unitAmount：面值
 * }
 * @returns
 * - name: 张  usdt  标记币
 * - digit:对应小数位
 * - unit:当前对象的单位类型
 */
export const unitText = ({
  digit,
  unit,
  quote,
  indexBase,
  unitAmount,
}: {
  indexBase: string
  unit: string
  indexBase: string
  quote: string
  unitAmount: string | number
}) => {
  let digitValue = 0,
    name = 'cont' //this.getKey('contractOrder_122')
  if (unit.toLocaleUpperCase() == 'USDT') {
    //当前交易对价格精度
    digitValue = digit
    name = 'USDT'
  } else if (unit == 'quote') {
    //币本位默认 4位， 金(U)本位 合约面值精度
    digitValue = quote.toLocaleUpperCase().indexOf('USDT') == -1 ? 4 : getUnitAmount(unitAmount)
    name = indexBase.toLocaleUpperCase()
  }
  return { name, digitValue, unit }
}

// @Morris 帮忙确认下逻辑
export const unitDigit = ({
  marketPriceDigit,
  unitType,
  quote,
  unitAmount,
}: {
  marketPriceDigit: number
  unitType: TUnitType
  quote: string
  unitAmount: string | number
}) => {
  if (unitType === 'usdt') {
    return marketPriceDigit
  }
  if (unitType === 'crypto') {
    //币本位默认 4位， 金(U)本位 合约面值精度
    return quote.toLocaleUpperCase().indexOf('USDT') === -1 ? 4 : getUnitAmount(unitAmount)
  }
  return 0
}

type ContractUnitParams = {
  /** 合约张数 */
  amount: string | number
  digit?: string | number | null
  price: string | number
  unit: TUnitType
  /** 合约面值 */
  unitAmount: string | number
  /** 是否为金本位 */
  isGoldStandard: boolean
}

/**
 * 合约单位转换函数
 * 根据不同单位类型将合约张数转换为对应的数值
 * @param digit initial 不进行小数位处理
 *
 * @description
 * 转换逻辑:
 * 1. USDT: 张*价格*面值
 * 2. 数字货币:
 *    - 金本位 btc : 张数 × 合约面值
 *    - 币本位 btc : (张数 × 合约面值) ÷ 最新价格
 * 3. 其他情况: 张数 × 合约面值
 *   获取合约精度
 * - USDT 模式：使用交易对价格精度(marketPriceDigit)
 * - 金本位模式：使用合约面值精度(getUnitAmount(unitAmount))
 * - 币本位模式：固定使用 4 位精度
 */
export const contractUnit = ({ amount, digit = 0, price, unit, unitAmount, isGoldStandard }: ContractUnitParams) => {
  if (unit === 'cont') {
    return showSpliceDecimal(amount, 0)
  }

  // 计算基础数量 (张数 × 合约面值)
  const numUnitAmount = BigNumberTimes(amount, unitAmount)

  let result = numUnitAmount
  if (unit && unit.toLocaleUpperCase() === 'USDT') {
    result = BigNumberTimes(price, numUnitAmount)
  } else {
    if (!isGoldStandard) {
      result = BigNumberDiv(numUnitAmount, price)
    }
  }
  return digit === 'initial' ? result : showSpliceDecimal(result, digit)
}

type contractUnitFromContParams = {
  amount: string | number
  price: string | number
  unitAmount: string | number
  unit: TUnitType
  /** 是否为金本位 */
  isGoldStandard: boolean
}
/**
 * 合约单位转换函数
 * 把其余单位数量转换为张数
 */
export const contractUnitFromCont = ({
  amount,
  price,
  unitAmount,
  unit,
  isGoldStandard,
  roundUp = false,
}: contractUnitFromContParams & { roundUp?: boolean }): number => {
  if (unit === 'cont') {
    return Number(showSpliceDecimal(amount, 0))
  }
  // 计算基础数量 (数量 / 合约面值)
  const numUnitAmount = BigNumberDiv(amount, unitAmount)

  let result = numUnitAmount
  if (unit && unit.toLocaleUpperCase() === 'USDT') {
    // 数量/面值/价格
    result = BigNumberDiv(numUnitAmount, price)
  } else {
    if (!isGoldStandard) {
      //数量 / 面值 * 价格
      result = BigNumberTimes(numUnitAmount, price)
    }
  }
  if (roundUp) {
    return Math.ceil(result) // 使用向上取整
  } else {
    if (result < 1) {
      return 1 // 小于1直接取一張
    } else {
      return Math.floor(result) // 大于等于1时向下取整
    }
  }
}
/**
 * 加法運算
 * @param num1 第一個數
 * @param num2 第二個數
 * @returns 相加結果
 */
export const BigNumberAdd = (num1: number | string, num2: number | string): string => {
  if ((!num1 && num1 !== 0) || (!num2 && num2 !== 0)) return ''

  const x = new BigNumber(num1)
  const y = new BigNumber(num2)
  const n = x.plus(y)
  return toNonExponential(new BigNumber(n))
}

/**
 * 減法運算
 * @param num1 被減數
 * @param num2 減數
 * @returns 相減結果
 */
export const BigNumberMinus = (num1: number | string, num2: number | string): string => {
  if ((!num1 && num1 !== 0) || (!num2 && num2 !== 0)) return ''

  const x = new BigNumber(num1)
  const y = x.minus(num2)
  return toNonExponential(new BigNumber(y))
}

/**
 * 乘法運算
 * @param num1 第一個因數
 * @param num2 第二個因數
 * @returns 相乘結果
 */
export const BigNumberTimes = (num1: number | string, num2: number | string): string => {
  if ((!num1 && num1 !== 0) || (!num2 && num2 !== 0)) return ''

  const x = new BigNumber(num1)
  const y = x.times(num2)
  return toNonExponential(new BigNumber(y))
}

/**
 * 除法運算
 * @param num1 被除數
 * @param num2 除數
 * @returns 相除結果
 */
export const BigNumberDiv = (num1: number | string, num2: number | string): string => {
  if ((!num1 && num1 !== 0) || (!num2 && num2 !== 0)) return ''

  const x = new BigNumber(num1)
  const y = x.div(num2)
  return toNonExponential(new BigNumber(y))
}

/**
 * 精度計算
 * @param decimal 小數位數
 * @returns 計算後的整數
 */
export const fixDepthNumber = (decimal: number): number => {
  let str = '1'
  if (decimal > 0) {
    for (let i = 1; i <= decimal; i++) {
      str = str + '0'
    }
  }
  return parseInt(str)
}

/**
 * 千分位加逗号
 */
export const thousandthCommaFilters = (value) => {
  if (!value && parseFloat(value) != 0) return ''
  // 使用toLocaleString,不能保留两位小时
  if (typeof value == 'undefined') {
    return value
  } else {
    const parts = value.toString().split('.')
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return parts.join('.')
  }
}

/**
 * 初始化方法
 * @param datafeedURL
 * @param ws
 * @param updateFrequency
 * @constructor
 */
export function compare(property) {
  return function (a, b) {
    const value1 = a[property]
    const value2 = b[property]
    return value1 - value2
  }
}

/**
 * 金额格式化
 * @param n - 要格式化的金额
 * @param c - 小数点后面有几位 (四舍五入到指定的位数)
 * @param d - 小数点符号（默认为 .）
 * @param t - 千分位符号（默认为 ,）
 * @returns 格式化后的金额字符串
 */
export const transformThousands = (n: number | string, c: number = 2, d: string = '.', t: string = ','): string => {
  if (!n || n < 1000) return n.toString()

  const val = n.toString()
  if (val.indexOf('.') != -1) {
    c = val.length - val.indexOf('.') - 1
  } else {
    c = 0
  }

  d = d == undefined ? '.' : d
  t = t == undefined ? ',' : t
  const s = n < 0 ? '-' : ''
  const i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c))))
  const j = i.length > 3 ? i.length % 3 : 0

  return (
    s +
    (j ? i.substr(0, j) + t : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) +
    (c
      ? d +
        Math.abs(n - parseFloat(i))
          .toFixed(c)
          .slice(2)
      : '')
  )
}

// 获取合约类型名称
export const createGetContractDeliverTypeText =
  (t: (k: string, placeholder?: Record<string, string | number | undefined>) => string) =>
  (contractType?: string, liquidationDate?: number) => {
    if (contractType && liquidationDate) {
      const contractTypeMap = {
        week: 'contract_375',
        nextWeek: 'contract_376',
        quarter: 'contract_377',
        nextQuarter: 'contract_378',
      }

      const key = contractTypeMap[contractType] || 'contractExchange_016'

      let text = t(key)

      if (contractType !== 'perpetual') {
        text = `${text}${dayjs(liquidationDate).format('MMDD')}`
      }

      return text
    }

    return ''
  }

type UnaryFunction<T, R> = (arg: T) => R

export function pipe<A>(a: A): A
export function pipe<A, B>(a: A, ab: UnaryFunction<A, B>): B
export function pipe<A, B, C>(a: A, ab: UnaryFunction<A, B>, bc: UnaryFunction<B, C>): C
export function pipe<A, B, C, D>(a: A, ab: UnaryFunction<A, B>, bc: UnaryFunction<B, C>, cd: UnaryFunction<C, D>): D
export function pipe<A, B, C, D, E>(
  a: A,
  ab: UnaryFunction<A, B>,
  bc: UnaryFunction<B, C>,
  cd: UnaryFunction<C, D>,
  de: UnaryFunction<D, E>
): E
export function pipe<A, B, C, D, E, F>(
  a: A,
  ab: UnaryFunction<A, B>,
  bc: UnaryFunction<B, C>,
  cd: UnaryFunction<C, D>,
  de: UnaryFunction<D, E>,
  ef: UnaryFunction<E, F>
): F
export function pipe(value: unknown, ...fns: UnaryFunction<unknown, unknown>[]): unknown {
  return fns.reduce((acc, fn) => fn(acc), value)
}

export const numberFormatter = (
  num: number | string,
  decimal: number = 2,
  formatLessThousand: boolean = false
): string => {
  if (isNaN(Number(num))) {
    return '--'
  }

  const si = [
    { value: 1, symbol: '' },
    { value: 1e3, symbol: 'K' },
    { value: 1e6, symbol: 'M' },
    { value: 1e9, symbol: 'B' },
    { value: 1e12, symbol: 'T' },
    { value: 1e15, symbol: 'P' },
    { value: 1e18, symbol: 'E' },
  ]

  let i
  for (i = si.length - 1; i > 0; i--) {
    if (Number(num) >= si[i].value) {
      break
    }
  }

  if (parseFloat(String(num)) >= 1000) {
    const number = (Number(num) / si[i].value).toString()
    return spliceDecimal(number, decimal) + si[i].symbol
  }

  return formatLessThousand ? spliceDecimal(num, decimal) : num
}

/**
 * 大数据精度展示 有更多配置项
 */
type TBigDataNumFloatByMoreSetParams = {
  num: string | number
  decimal?: number // 折算后的精度
  isTransformThousands?: boolean // 是否  千分位显示
  isAddZero?: boolean // 是否补0 默认不补0
  noFormatDecimal?: number // 不折算时的精度
}
export const createBigDataNumFloatByMoreSet =
  (lang: TLanguages) =>
  ({ num, decimal, isTransformThousands, isAddZero, noFormatDecimal }: TBigDataNumFloatByMoreSetParams) => {
    let newNum = num !== undefined || num !== null ? String(num) : '--'
    const nn = Number(newNum)
    const splitFn = isAddZero ? showSpliceDecimal : spliceDecimal
    //为0的话默认显示2位
    decimal = decimal !== undefined ? decimal : 4
    noFormatDecimal = noFormatDecimal !== undefined ? noFormatDecimal : decimal

    if (lang === 'zh_CN' || lang === 'zh_HK') {
      const TenThousand = 10000
      const Billion = 100000000
      const Trillion = 1000000000000
      if (nn >= TenThousand && nn < Billion) {
        let val = splitFn(newNum / TenThousand, decimal)
        val = isTransformThousands ? transformThousands(val) : val
        newNum = val + (lang === 'zh_HK' ? '萬' : '万')
      }
      if (nn >= Billion && nn < Trillion) {
        let val = splitFn(newNum / Billion, decimal)
        val = isTransformThousands ? transformThousands(val) : val
        newNum = val + (lang === 'zh_HK' ? '億' : '亿')
      }
      if (nn >= Trillion) {
        let val = spliceDecimal(newNum / Trillion, decimal)
        newNum = val + (lang === 'zh_HK' ? '萬億' : '万亿')
      }
      if (nn < TenThousand) {
        let val = splitFn(newNum, noFormatDecimal)
        val = isTransformThousands ? transformThousands(val) : val
        newNum = val
      }
    } else {
      const thousand = 1000
      const million = 1000000
      const Billion = 1000000000
      const trillion = 1000000000000
      if (nn < thousand) {
        let val = splitFn(newNum, noFormatDecimal)
        val = isTransformThousands ? transformThousands(val) : val
        newNum = val
      }
      if (nn > thousand && nn < million) {
        let val = splitFn(newNum / thousand, decimal)
        val = isTransformThousands ? transformThousands(val) : val
        newNum = val + 'K'
      }
      if ((nn > million || nn == million) && nn < Billion) {
        let val = splitFn(newNum / million, decimal)
        val = isTransformThousands ? transformThousands(val) : val
        newNum = val + 'M'
      }
      if ((nn > Billion || nn == Billion) && nn < trillion) {
        let val = splitFn(newNum / Billion, decimal)
        val = isTransformThousands ? transformThousands(val) : val
        newNum = val + 'B'
      }
      if (nn > trillion || nn == trillion) {
        let val = splitFn(newNum / trillion, decimal)
        val = isTransformThousands ? transformThousands(val) : val
        newNum = val + 'T'
      }
    }

    return newNum
  }
/**
 * 金钱格式化，三位加逗号
 *  @param { number } num
 */
export const formatMoney = (num: number) => {
  if (!num) {
    return 0
  }
  let value = num.toString().split('.')
  let n = value[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  if (value.length > 1) {
    n = n + '.' + value[1]
  }
  return n
}

export const toDateString = (timestamp: number, format?: string) => {
  if (timestamp == '' || timestamp == null || typeof timestamp === 'undefined') {
    return ''
  }
  let dd = new Date()
  dd.setTime(timestamp)
  if (typeof format === 'undefined') {
    format = 'yyyy-MM-dd'
  }
  let o = {
    'M+': dd.getMonth() + 1, //month
    'd+': dd.getDate(), //day
    'h+': dd.getHours(), //hour
    'm+': dd.getMinutes(), //minute
    's+': dd.getSeconds(), //second
    'q+': Math.floor((dd.getMonth() + 3) / 3), //quarter
    S: dd.getMilliseconds(), //millisecond
  }
  if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (dd.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (let k in o)
    if (new RegExp('(' + k + ')').test(format))
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
  return format
}

// 获取当前时间的时区偏移量（单位为分钟）
export const getCurrentUTCOffset = (): string => {
  const offsetMinutes = new Date().getTimezoneOffset()
  // 计算当前时区相对于UTC时间的偏移量
  const offsetHours = offsetMinutes / 60
  const offsetDirection = offsetHours > 0 ? '-' : '+'
  const offsetHoursAbs = Math.abs(offsetHours)

  return 'UTC' + offsetDirection + offsetHoursAbs
}

export const getTradeHref = (sellCoinShortName: string, buyCoinShortName: string, tradeAres?: number) => {
  let tradeName = sellCoinShortName.toLowerCase() + '_' + buyCoinShortName.toLowerCase()
  if (tradeAres == 6) {
    tradeName = sellCoinShortName.toLowerCase() + '_' + 'etf'
  }
  if (tradeAres == 8) {
    tradeName = sellCoinShortName.toLowerCase() + '_' + 'alts'
  }
  return `/trade/exchange/?tradeCode=${tradeName}`
}

// 从URL获取语言
export const getLangFromUrl = () => {
  if (typeof window !== 'undefined') {
    const pathSegments = window.location.pathname.split('/')
    const urlLang = pathSegments?.[1]
    return urlLang || 'en_US'
  }
  return 'en_US'
}
